import { Building, CreditCard, Earth, MessageCircleMore, Scale, ZapIcon } from "lucide-react";

import { motion } from "framer-motion";
import { useMediaQuery } from "@mui/material";

const list = [
    {
        id: 1,
        title: "Zavkladovanie na príslušnom katastri",
        description: "Zabezpečíme podanie návrhu na vklad vlastníckeho práva do katastra nehnuteľností po podpise kúpnej zmluvy.",
        icon: <Building size={56} />
    },
    {
        id: 2,
        title: "Pomoc s vybavením trvalého pobytu v Maďarsku a \"Lakcím\" karty",
        description: "Po prechode nehnuteľnosti do osobného vlastníctva asistujeme pri získaní Lakcím karty a trvalého pobytu v Maďarsku na cudzineckej polícii.",
        icon: <CreditCard size={56} />
    },
    {
        id: 3,
        title: "Zabezpečenie autorizovaného právnika",
        description: "Zabezpečíme termín u overeného autorizovaného právnika na vyhotovenie kúpno-predajnej zmluvy.",
        icon: <Scale size={56} />
    },
    {
        id: 4,
        title: "Tlmočenie v zahraničí pred úradmi",
        description: "V prípade neovládania maďarského jazyka sprostredkujeme tlmočníka alebo splnomocnenú osobu na zastupovanie.",
        icon: <Earth size={56} />
    },
    {
        id: 5,
        title: "Komunikácia s daňovým úradom a pozemkovým úradom",
        description: "Zastúpime vás v komunikácii s daňovým a pozemkovým úradom v Maďarsku v súvislosti s prevodom nehnuteľnosti.",
        icon: <MessageCircleMore size={56} />
    },
    {
        id: 6,
        title: "Spoluúčasť na prepise energií",
        description: "Po prechode nehnuteľnosti do osobného vlastníctva vám pomôžeme s prepisom energií na vaše meno.",
        icon: <ZapIcon size={48} />
    }

]


const HelpWithPanel = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    return (
        <div className="flex flex-col gap-2" style={{ padding: "2rem", gap: '1rem' }}>
            <div className="flex flex-col" style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                <h2 className="text-3xl font-bold text-[#9b8b4b]" style={{ fontSize: '2rem', color: '#9b8b4b', margin: 0 }}>S čím Vám vieme pomôcť?</h2>
                <p className="text-gray-600 mt-1" style={{ fontWeight: '500', fontSize: '1.2rem', margin: 0 }}>
                    U Nás sa nemusíte o nič starať, všetko zariadime za Vás a budeme tam pre Vás počas celého procesu, a aj po ňom.
                </p>
            </div>
            <div className="flex flex-col justify-center items-center gap-3">   
           



                {list.map((item, index) => (
                    <motion.div
                        key={item.id}
                        className="flex w-full max-w-full items-center justify-between gap-2 rounded-xl p-4 bg-white/50"
                        initial={isMobile ? { x: index % 2 === 0 ? -20 : 20, opacity: 0 } : { x: index % 2 === 0 ? -30 : 30, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.6, ease: "easeInOut" }}
                    >
                        {index % 2 === 0 ? (
                            <div className="flex items-center gap-2 w-full">
                                <div
                                    className="w-10 h-10 rounded-full flex items-center justify-center"
                                    style={{ color: "#9b8b4b", marginRight: '1rem' }}
                                >
                                    {item.icon}
                                </div>
                                <div className="flex flex-col">
                                    <p style={{ fontSize: '1.2rem', fontWeight: '500', minWidth: '100px', maxWidth: '400px' }}>{item.title}</p>
                                    <p style={{ fontSize: '1rem', fontWeight: '500', minWidth: '100px', maxWidth: '400px', color: 'gray' }}>{item.description}</p>
                                </div>
                            </div>
                        ) : (
                            <div className="flex items-center gap-2 justify-end text-right w-full">
                                <div className="flex flex-col">
                                    <p style={{ fontSize: '1.2rem', fontWeight: '500', minWidth: '100px', maxWidth: '400px' }}>{item.title}</p>
                                    <p style={{ fontSize: '1rem', fontWeight: '500', minWidth: '100px', maxWidth: '400px', color: 'gray' }}>{item.description}</p>
                                </div>
                                <div
                                    className="w-10 h-10 rounded-full flex items-center justify-center"
                                    style={{ color: "#9b8b4b", marginLeft: '1rem' }}
                                >
                                    {item.icon}
                                </div>
                            </div>
                        )}
                    </motion.div>
                ))}


            </div>
        </div>
    )
}

export default HelpWithPanel;